import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { InfrastructurerequestService } from './infrastructurerequest.service';
import { global } from '../../shared/global';
import { InfrastructureRequest } from '../Models/infrastructurereq.model';
import { schoolfullregistrationrequestService } from '../School/schoolfullregistrationrequest/schoolfullregistrationrequest.service';
declare var $: any;

@Component({
  selector: 'app-infrastructurerequest',
  templateUrl: './infrastructurerequest.component.html',
  styleUrls: ['./infrastructurerequest.component.css']
})
export class InfrastructurerequestComponent implements OnInit {

  @ViewChild('infrastructurereq') infrastructurereq: NgForm;
  searchtext;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  dropDownData: any;
  data: InfrastructureRequest;
  submitted: boolean;
  btnsubmittext = "Add";
  InfrastructureRequestList: any;
  infrastructures: any;
  infraname:any;
  totalInfra:any;
  totalPages = 10;

  constructor(private service: InfrastructurerequestService, private regservice: schoolfullregistrationrequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {

    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/collegelogin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.GetInfrastructureList(this.p);
});
    this.data = new InfrastructureRequest();
    $("#searchtext").val("");
    this.fillInfrastructure();
    this.GetInfrastructureList(this.p);
  }
  fillInfrastructure() {
    const data = {
    };
    this.regservice.fillInfrastructure(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.infrastructures = this.dropDownData.dropdownlist;
        this.data.InfrastructureID = 0;
      });
  }
  GetInfrastructureList(page) {
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      YearID: +localStorage.getItem("yearID"),
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit
    };
    this.service.getInfrastructureRequestList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.InfrastructureRequestList = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.InfrastructureRequestList = this.responseData.InfrastructureRequestList;
          this.totalInfra = this.responseData.totalCount;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }
  onSubmit(data) {
    this.submitted = true;
    if (this.data.InfrastructureID == 0 || this.data.InfrastructureID == undefined) {
      return;
    }
    if(($.trim(this.infraname.toLowerCase()) == "other") && ($.trim(data.OtherInfrastructure) == "" || $.trim(data.OtherInfrastructure) == undefined)){
      this.toastr.error("Other infrastructure is required");
      return;
    }
    if (this.infrastructurereq.valid) {
      this.data.YearID = parseInt(localStorage.getItem("yearID"));
      this.spinner.show();
      this.service.saveInfrastructureRequest(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.GetInfrastructureList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }
  editInfrastructureRequest(HashCode) {
    this.spinner.show();
    const data = {
      HashCode: HashCode,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getInfrastructureRequestByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          setTimeout(() => { 
          this.getInfraName();
        }, 1000);
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  deleteInfrastructureRequest(HashCode) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode
      }
      this.spinner.show();
      this.service.deleteInfrastructureRequest(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.GetInfrastructureList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }
  getInfraName(){
    this.infraname = $("#InfrastructureID :selected").text();
    if($.trim(this.infraname.toLowerCase()) == "other"){
      $("#divotherinfra").css("display","block");
    }
    else{
      $("#divotherinfra").css("display","none");
    }
  }

  resetForm() {
    this.data.ID = 0;
    this.data.InfrastructureID = 0;
    this.data.InfrastructureSize = null;
    this.data.NoOfInfrastructure = null;
    this.data.OtherInfrastructure = null;
    this.submitted = false;
    this.btnsubmittext = "Add";
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.InfrastructureRequestList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }
}
